import { NavLink } from "react-router-dom";
import { Home, ClipboardList, Wrench, ShieldCheck, UserCog, Briefcase } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// Map & Profile live in the TopBar now (top-right) to avoid the floating badge.
const clientTabs = [
  { to: "/app", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/app/requests", label: "Requests", icon: ClipboardList, testid: "nav-requests" },
];

const mechanicTabs = [
  { to: "/app", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/app/jobs", label: "Jobs", icon: Wrench, testid: "nav-jobs" },
];

const adminTabs = [
  { to: "/app", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/app/admin/pending", label: "Pending", icon: ShieldCheck, testid: "nav-pending" },
  { to: "/app/admin/users", label: "Users", icon: UserCog, testid: "nav-users" },
  { to: "/app/admin/jobs", label: "Jobs", icon: Briefcase, testid: "nav-admin-jobs" },
];

export default function BottomNav() {
  const { user } = useAuth();
  if (!user) return null;
  const tabs =
    user.role === "mechanic" ? mechanicTabs : user.role === "admin" ? adminTabs : clientTabs;

  // Leave room on the right so the Emergent badge (bottom-right, fixed) never overlaps a tab.
  const cols = tabs.length === 2 ? "grid-cols-2" : "grid-cols-4";

  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-[#0A0A0A]/90 backdrop-blur-xl border-t border-white/10 z-50 pr-16"
      data-testid="bottom-nav"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className={`grid ${cols} h-16`}>
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === "/app"}
              data-testid={t.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 active:scale-95 transition-transform ${
                  isActive ? "text-[#3CFF7E]" : "text-[#9CA3AF]"
                }`
              }
            >
              <Icon size={20} strokeWidth={2.2} />
              <span className="text-[10px] font-bold uppercase tracking-wider font-display">
                {t.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
